import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";

const today = () => new Date().toISOString().slice(0, 10);
const getContext = () => ({
  academicYearId: localStorage.getItem("academicSessionId"),
  orgId: localStorage.getItem("orgId"),
  branchId: localStorage.getItem("branchId"),
});

export default function AdmDocumentUpload() {
  const navigate = useNavigate();
  const [teachers, setTeachers] = useState([]);
  const [teacherId, setTeacherId] = useState("");
  const [fromDate, setFromDate] = useState(today());
  const [toDate, setToDate] = useState(today());
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const loadTeachers = async () => {
      const { orgId, branchId } = getContext();
      if (!orgId || !branchId) return setMessage("Academic session details are missing.");
      try {
        const params = new URLSearchParams({ orgId, branchId });
        const response = await fetch(`${ApiUrl.apiurl}Teacher/GetEmployeeList/?${params}`);
        const data = await response.json();
        if (!response.ok || !Array.isArray(data.data)) throw new Error(data.message || "Could not load teachers.");
        setTeachers(data.data.map((teacher) => ({
          id: teacher.id,
          name: teacher.employeeName || teacher.employee_name || teacher.name || `Staff #${teacher.id}`,
        })));
      } catch (error) {
        setMessage(error.message || "Could not load teachers.");
      }
    };
    loadTeachers();
  }, []);

  const displayDocuments = async () => {
    const { academicYearId, orgId, branchId } = getContext();
    if (!academicYearId || !orgId || !branchId) return setMessage("Academic session details are missing.");
    if (fromDate && toDate && fromDate > toDate) return setMessage("From date cannot be after to date.");
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (teacherId) params.set("teacherId", teacherId);
      if (fromDate) params.set("fromDate", fromDate);
      if (toDate) params.set("toDate", toDate);
      const response = await fetch(`${ApiUrl.apiurl}ACADEMIC_DOCUMENTS/${academicYearId}/${orgId}/${branchId}/?${params}`);
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Could not load documents.");
      setDocuments(Array.isArray(data.data) ? data.data : []);
      setMessage("");
    } catch (error) {
      setDocuments([]);
      setMessage(error.message || "Could not load documents.");
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    setTeacherId("");
    setFromDate(today());
    setToDate(today());
    setDocuments([]);
    setMessage("");
  };

  const teacherName = (id) => teachers.find((teacher) => String(teacher.id) === String(id))?.name || `Staff #${id}`;

  // react-select options + current value
  const teacherOptions = teachers.map((teacher) => ({
    value: teacher.id,
    label: teacher.name,
  }));
  const selectedTeacherOption =
    teacherOptions.find((option) => String(option.value) === String(teacherId)) || null;

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card p-0">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                ACADEMIC DOCUMENTS UPLOAD
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={displayDocuments}
                    disabled={loading}
                  >
                    Display
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={clearFilters}
                    disabled={loading}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-3 mt-3">
                        <label className="form-label">Teacher</label>
                        <Select
                          classNamePrefix="detail-select"  className=" detail"
                          value={selectedTeacherOption}
                          onChange={(option) => setTeacherId(option ? option.value : "")}
                          options={teacherOptions}
                          placeholder="All teachers"
                          isSearchable
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base) => ({
                              ...base,
                              minHeight: "38px",
                            }),
                          }}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-0 mt-3">
                        <label className="form-label">From Date</label>
                        <input
                          type="date"
                          className="form-control detail"
                          value={fromDate}
                          onChange={(event) => setFromDate(event.target.value)}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-0 mt-3">
                        <label className="form-label">To Date</label>
                        <input
                          type="date"
                          className="form-control detail"
                          value={toDate}
                          onChange={(event) => setToDate(event.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table className="table table-bordered ">
                  <thead >
                    <tr>
                      <th>Sr.No</th>
                      <th>Teacher Name</th>
                      <th>Upload Date</th>
                      <th>View Attachment</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          Loading…
                        </td>
                      </tr>
                    ) : documents.length ? (
                      documents.map((document, index) => (
                        <tr key={document.doc_id}>
                          <td>{index + 1}</td>
                          <td>{teacherName(document.created_by)}</td>
                          <td>{document.upload_date}</td>
                          <td>
                            <a
                              href={`${ApiUrl.apiurl}ACADEMIC_DOCUMENTS/download/${document.doc_id}/`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              View / Download
                            </a>
                          </td>
                          <td>{document.remarks || "-"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No documents found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
